<template>
  <div class="modal-overlay" v-if="member" @click.self="$emit('close')">
    <div class="modal">
      <button class="close-button" @click="$emit('close')">✖</button>
      <h3>{{ member.name }}</h3>
      <p>{{ member.role }}</p>
      <div class="photos-grid">
        <div
          class="photo-card"
          v-for="(photo, idx) in getPaths"
          :key="idx"
          @click="$emit('open-photo', getPhotoPath(idx + 1))"
          @mouseover="preloadImage(idx)"
        >
          <img :src="photo" alt="Member photo" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoAlbum',
  props: { member: Object },
  computed: {
    getPaths() {
      const list = [];
      for (let i = 1; i <= 6; i++) {
        list.push(
          `/media/photos/members/${this.member.albumName}/thumbnails/${i}.webp`
        );
      }

      return list;
    },
  },
  methods: {
    getPhotoPath(index) {
      return `/media/photos/members/${this.member.albumName}/${index}.webp`;
    },
    preloadImage(index) {
      const img = new Image();
      img.src = this.getPhotoPath(index);
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(4, 1, 1, 0.943);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
}

.modal {
  background: #111;
  color: #eee;
  padding: 1rem;
  border-radius: 15px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  text-align: center;
  position: relative;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  color: #fff;
  border: none;
  font-size: 1.8rem;
  cursor: pointer;
}

h3 {
  margin: 0;
  padding: 0;
  color: #909078;
  font-size: 1.25rem;
}

p {
  font-size: 1rem;
  color: #86868d;
}

.photos-grid {
  margin-top: 1.5rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
  justify-items: center;
}

.photo-card {
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.6);
  cursor: pointer;
  transition: transform 0.3s ease;
}

.photo-card:hover {
  transform: scale(1.05);
}

.photo-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
</style>
